import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAbility } from '@features/authorization';

/**
 * Admin Dashboard Page
 *
 * Route: /:locale/admin/
 */
export const Route = createFileRoute('/$locale/_authenticated/admin/')({
  component: AdminDashboardRedirect,
});

function AdminDashboardRedirect() {
  const { locale } = Route.useParams();
  const ability = useAbility();
  return (
    <Navigate
      to={ability.can('manage', 'all') ? '/$locale/admin/overview' : '/$locale/admin/settings'}
      params={{ locale }}
      replace
    />
  );
}
